import {
  Button,
  SearchBox,
  OutlinedSelect,
  OutlinedSelectOptionType,
} from '@octano/global-ui';
import { useCallback } from 'react';
import { Col, Row } from 'reactstrap';
import { useValidations } from '../../../../hooks/useValidations';
import { StudentsRemovalRequestsResolvedFiltersResponse } from '../types';
import { useGetStateOptionsFromValues } from './hooks/useGetStateOptionsFromValues';
import { useTexts } from './hooks/useTexts';
import { useStudentsRemovalRequestsResolvedList } from './StudentsRemovalRequestsResolvedListLoader';
import { useForm } from 'react-hook-form';

interface StudentsRemovalRequestsResolvedFiltersForm {
  studentNameOrId: string;
  studyPlanVersion: OutlinedSelectOptionType | null;
  requestState: OutlinedSelectOptionType | null;
}

export function StudentsRemovalRequestsResolvedFilters({
  data,
}: {
  data: StudentsRemovalRequestsResolvedFiltersResponse;
}) {
  const formDefaultValues: StudentsRemovalRequestsResolvedFiltersForm = {
    studentNameOrId: '',
    studyPlanVersion: null,
    requestState: null,
  };
  const {
    control,
    handleSubmit,
    reset,
  } = useForm<StudentsRemovalRequestsResolvedFiltersForm>({
    defaultValues: formDefaultValues,
  });

  const { updateQuery } = useStudentsRemovalRequestsResolvedList();
  const texts = useTexts().filters;
  const { validateMinLength } = useValidations();
  const studyPlanVersionsOptions = data.studyPlanVersions.map((s) => ({
    value: s.id,
    label: s.name,
  }));

  const requestStatesOptions = useGetStateOptionsFromValues(data.requestStates);
  const localSubmit = useCallback(
    (values: StudentsRemovalRequestsResolvedFiltersForm) => {
      updateQuery({
        page: 1,
        studentNameOrId: values.studentNameOrId,
        studyPlanVersionId:
          typeof values.studyPlanVersion?.value === 'number'
            ? values.studyPlanVersion?.value
            : undefined,
        requestState: values.requestState?.value.toString() || undefined,
      });
    },
    [updateQuery],
  );
  return (
    <form onSubmit={handleSubmit(localSubmit)}>
      <Row>
        <Col xs={12} md={3}>
          <SearchBox
            name="studentNameOrId"
            label={texts.student}
            placeholder={texts.studentPlaceholder}
            control={control}
            minLength={3}
            rules={{
              validate: {
                minLength: validateMinLength(3),
              },
            }}
            clear={() => reset({ studentNameOrId: '' })}
          />
        </Col>
        <Col xs={12} md={3}>
          <OutlinedSelect
            name="studyPlanVersion"
            label={texts.studyPlanVersionName}
            placeholder={texts.studyPlanVersionNamePlaceholder}
            control={control}
            options={studyPlanVersionsOptions}
          />
        </Col>
        <Col xs={12} md={3}>
          <OutlinedSelect
            name="requestState"
            label={texts.requestStateName}
            placeholder={texts.requestStateNamePlaceholder}
            control={control}
            options={requestStatesOptions}
          />
        </Col>
        <Col xs={12} md={3} className="ml-auto">
          <div className="d-flex justify-content-end mt-4">
            <Button
              type="submit"
              color="primary"
              className="mb-3"
              size="md"
              text={texts.search}
            />
            <Button
              color="primary"
              outlined
              className="mb-3 ml-2"
              onClick={() => {
                reset(formDefaultValues);
                updateQuery({ page: 1 });
              }}
              size="md"
              text={texts.clean}
            />
          </div>
        </Col>
      </Row>
    </form>
  );
}
